import { ArrowLeft } from "lucide-react";

export default function JalonPage() {
  return (
    <div className="relative w-full h-screen">
      <a
        href="/"
        className="fixed top-4 left-4 z-50 inline-flex items-center gap-2 px-4 py-2 bg-white/90 backdrop-blur-sm border border-[#E6DED5] rounded-full text-sm font-body text-[#595959] hover:text-[#C5A880] hover:border-[#C5A880] transition-all shadow-sm"
        data-testid="jalon-back-btn"
      >
        <ArrowLeft size={16} />
        Retour au site
      </a>
      <iframe
        src="/jalon-v2.html"
        title="Jalon - Clarifiez votre projet"
        className="w-full h-full border-0"
        data-testid="jalon-iframe"
      />
    </div>
  );
}
